
<div>
  <slot v-for="i in Array(length).keys()" :name="i + 1"></slot>
</div>
